import { render, staticRenderFns } from "./workshops-map.vue?vue&type=template&id=93cb21f4&scoped=true&"
import script from "./workshops-map.vue?vue&type=script&lang=js&"
export * from "./workshops-map.vue?vue&type=script&lang=js&"
import style0 from "./workshops-map.vue?vue&type=style&index=0&id=93cb21f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cb21f4",
  null
  
)

export default component.exports